import { Link as RouterLink, useLocation } from "react-router-dom";
// hooks
import useLocales from "../../hooks/useLocales";
// constants
import { APP_ROUTES } from "../../common/constants";
// utils
import { capitalEvery } from "../../utils/textEnhancers";

const NavigationMenu = () => {
  const { translate } = useLocales();
  const { pathname } = useLocation();

  if (pathname.includes(APP_ROUTES.CUSTOMERS)) {
    return null;
  }

  return (
    <ui-nav-menu>
      {/* DASHBOARD */}
      <RouterLink to={APP_ROUTES.DASHBOARD} rel="home" active={{ value: pathname === APP_ROUTES.DASHBOARD }} />
      {/*  */}

      {/* PRODUCTS */}
      <RouterLink to={APP_ROUTES.PRODUCTS.ROOT}>{capitalEvery(translate("nav.products"))}</RouterLink>
      {/*  */}

      {/* SETTINGS */}
      <RouterLink to={APP_ROUTES.SETTINGS.ROOT}>{capitalEvery(translate("nav.settings"))}</RouterLink>
      {/*  */}

      {/* NOTIFICATIONS */}
      <RouterLink to={APP_ROUTES.NOTIFICATIONS.ROOT}>{capitalEvery(translate("nav.notifications"))}</RouterLink>
      {/*  */}

      {/* ORDERS */}
      <RouterLink to={APP_ROUTES.ORDERS.ROOT}>{capitalEvery(translate("page.dashboard.orders-card-title"))}</RouterLink>
      {/*  */}

      {/* TAG AUTOMATIONS */}
      <RouterLink to={APP_ROUTES.AUTOMATIONS.TAGS}>{capitalEvery(translate("nav.tag-automations"))}</RouterLink>
      {/*  */}

      {/* ACCOUNT */}
      <RouterLink to={APP_ROUTES.ACCOUNT.ROOT}>{capitalEvery(translate("nav.account"))}</RouterLink>
      {/*  */}

      {/* BACK IN STOCK */}
      <RouterLink to={APP_ROUTES.BACKINSTOCK}>{capitalEvery(translate("nav.back-in-stock"))}</RouterLink>
      {/*  */}

      {/* ACTIVITY LOG */}
      <RouterLink to={APP_ROUTES.ACTIVITY_LOG}>{capitalEvery(translate("common.activity-log"))}</RouterLink>
      {/*  */}

      {/* INTEGRATIONS */}
      <RouterLink to={APP_ROUTES.INTEGRATIONS}>{capitalEvery(translate("nav.integrations"))}</RouterLink>
      {/*  */}
    </ui-nav-menu>
  );
};

export default NavigationMenu;
